import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface SpaceStore {
  spaceId: string | null;
}

interface SpaceStoreActions {
  setSpaceId: (spaceId: string) => void;
  clearSpaceId: () => void;
}

export const useSpaceStore = create<SpaceStore & SpaceStoreActions>()(
  devtools(
    persist(
      (set) => ({
        spaceId: null,
        setSpaceId: (spaceId: string) => set({ spaceId }),
        clearSpaceId: () => set({ spaceId: null }),
      }),
      {
        name: 'space-store',
        storage: {
          getItem: (name) => {
            if (typeof window === 'undefined') return null;
            const value = window.sessionStorage.getItem(name);
            return value ? JSON.parse(value) : null;
          },
          setItem: (name, value) => {
            if (typeof window === 'undefined') return;
            window.sessionStorage.setItem(name, JSON.stringify(value));
          },
          removeItem: (name) => {
            if (typeof window === 'undefined') return;
            window.sessionStorage.removeItem(name);
          },
        },
      },
    ),
    {
      name: 'SpaceStore',
      enabled: process.env.NEXT_PUBLIC_NODE_ENV !== 'production',
    },
  ),
);
